import React, { useState } from "react";

import {Link} from "react-router-dom";
import Scrollchor from 'react-scrollchor';

const Navigation = props => {
	const [isChecked, setIsChecked] = useState(false);


	const renderLogo = () =>  {
		if(props.isHome) {
			return (
				<Scrollchor to="#mainHeader" className="navLink">
					<div className="logo"> </div>
				</Scrollchor>
			)
		} else {
			return (
				<Link to="/">
					<div className="logo"> </div>
				</Link>
			)
		}
	}

	const renderLogoSvg = () => {
		if(props.isHome) {
			return (
				<Scrollchor to="#mainHeader" className="navLink">
					<svg className="logo--svg" width="1726" height="1095" viewBox="0 0 1726 1095" fill="none"
						 xmlns="http://www.w3.org/2000/svg">
						<g clipPath="url(#clip0)">
							<path
								d="M102.099 596.67L3.6836 496.672L37.5566 432.246L301.299 449.724C302.233 449.786 302.578 450.981 301.821 451.531L102.099 596.67ZM102.099 596.67L271.785 769.137L571.621 798.439C572.76 798.551 573.163 796.972 572.109 796.524L102.099 596.67Z"
								stroke="white" strokeWidth="21" strokeMiterlimit="10"/>
							<path d="M449.127 479L158.402 584H327.637L449.127 479Z" stroke="white" strokeWidth="21"
								  strokeMiterlimit="10"/>
							<path d="M302.316 450C441.091 481.011 449.558 478.845 449.558 478.845L302.316 450Z"
								  stroke="white" strokeWidth="21" strokeMiterlimit="10"/>
							<path d="M10.4102 494.599L304.247 450" stroke="white" strokeWidth="21"
								  strokeMiterlimit="10"/>
							<path
								d="M272.374 770L415.685 849.732M415.685 849.732L443.151 934.97M415.685 849.732C415.685 849.732 415.765 849.815 497.044 827.262C578.323 804.708 579.444 807.196 579.444 807.196L490.718 877.343M415.685 849.732L490.718 877.343M443.151 934.97C443.151 934.97 507.694 1019.3 524.591 1022.7C541.567 1026.01 498.806 1008.52 490.718 877.343M443.151 934.97L490.718 877.343"
								stroke="white" strokeWidth="21" strokeMiterlimit="10"/>
							<path d="M115.552 592.524L553.098 722.372L624.608 657.448L324.53 583" stroke="white"
								  strokeWidth="21" strokeMiterlimit="10"/>
							<path d="M579.519 799L669.344 715.478L621.973 657L579.519 799Z" stroke="white"
								  strokeWidth="21" strokeMiterlimit="10"/>
							<path
								d="M489.888 875.569L631.851 893.476L760.741 1022.59L844.475 1086.1L950.908 1072.46L844.475 947.447V893.476L741.837 800.545L1135.11 749.114C1136.33 748.954 1136.7 750.711 1135.52 751.063L1027.18 783.442M1027.18 783.442L805.818 850.685C804.717 851.019 804.958 852.642 806.108 852.642H919.708L1027.18 783.442Z"
								stroke="white" strokeWidth="21" strokeMiterlimit="10"/>
							<path
								d="M738.609 805.557L1008.63 500.838M738.609 805.557L624.177 655.81L449.127 477.29L1008.63 500.838M738.609 805.557L632.672 890.699C632.165 891.106 631.411 890.93 631.138 890.34L552.588 720.816M1008.63 500.838L1135.27 750.39C1135.57 750.984 1136.36 751.123 1136.85 750.667L1531.54 380.526C1531.54 380.526 1494.22 320.826 1490.22 269.5L1423.6 389.895L1008.63 500.838Z"
								stroke="white" strokeWidth="21" strokeMiterlimit="10"/>
							<path d="M731.352 497.667L624.608 657.448" stroke="white" strokeWidth="21"
								  strokeMiterlimit="10"/>
							<path d="M801.02 858.687L767.867 1028.09" stroke="white" strokeWidth="21"
								  strokeMiterlimit="10"/>
							<path d="M844.649 946V1086" stroke="white" strokeWidth="21" strokeMiterlimit="10"/>
							<path d="M1260.03 435.314L1283.41 615.243" stroke="white" strokeWidth="21"
								  strokeMiterlimit="10"/>
							<path d="M1420.34 392.445L1475.68 434.899" stroke="white" strokeWidth="21"
								  strokeMiterlimit="10"/>
							<path d="M1475.68 434.899L1501.86 319.064" stroke="white" strokeWidth="21"
								  strokeMiterlimit="10"/>
							<path d="M1424.11 391.451L1487.61 382.33" stroke="white" strokeWidth="21"
								  strokeMiterlimit="10"/>
							<path d="M1528 377L1614.33 483.419" stroke="white" strokeWidth="21"
								  strokeMiterlimit="10"/>
							<path d="M1551.99 407.371L1690.05 444.849" stroke="white" strokeWidth="21"
								  strokeMiterlimit="10"/>
							<path
								d="M254.988 439.5C268.041 393.896 326.318 207.541 490.638 98.1736C523.309 76.4494 641.424 2.90209 793.813 9.03794C1004.5 17.5784 1203.17 182.169 1301.5 415"
								stroke="white" strokeWidth="21" strokeMiterlimit="10"/>
							<path d="M1042.65 380C1042.65 380 817.596 229.928 490.638 98.1736" stroke="white"
								  strokeWidth="21" strokeMiterlimit="10"/>
							<path d="M373.79 462.5C373.79 462.5 541.567 324.371 762.903 221.803" stroke="white"
								  strokeWidth="21" strokeMiterlimit="10"/>
							<path d="M1035.17 86.8969C1035.17 86.8969 1058.15 411.848 1038.61 494.599" stroke="white"
								  strokeWidth="21" strokeMiterlimit="10"/>
							<path d="M494.722 478.928L510.097 363.922" stroke="white" strokeWidth="21"
								  strokeMiterlimit="10"/>
							<path d="M560.684 437.5L449.558 478.928" stroke="white" strokeWidth="21"
								  strokeMiterlimit="10"/>
							<path d="M586.28 485L549.094 434" stroke="white" strokeWidth="21" strokeMiterlimit="10"/>
							<path d="M1472 430L1605.5 479L1686.5 445.5L1717 411.5L1625 427" stroke="white"
								  strokeWidth="21"/>
						</g>
						<defs>
							<clipPath id="clip0">
								<rect width="1726" height="1095" fill="white"/>
							</clipPath>
						</defs>
					</svg>
				</Scrollchor>
			)
		} else {
			return (
				<Link to="/">
					<svg className="logo--svg" width="1726" height="1095" viewBox="0 0 1726 1095" fill="none"
						xmlns="http://www.w3.org/2000/svg">
						<g clipPath="url(#clip0)">
							<path
								d="M102.099 596.67L3.6836 496.672L37.5566 432.246L301.299 449.724C302.233 449.786 302.578 450.981 301.821 451.531L102.099 596.67ZM102.099 596.67L271.785 769.137L571.621 798.439C572.76 798.551 573.163 796.972 572.109 796.524L102.099 596.67Z"
								stroke="white" strokeWidth="21" strokeMiterlimit="10"/>
							<path d="M449.127 479L158.402 584H327.637L449.127 479Z" stroke="white" strokeWidth="21"
								  strokeMiterlimit="10"/>
							<path d="M302.316 450C441.091 481.011 449.558 478.845 449.558 478.845L302.316 450Z"
								  stroke="white" strokeWidth="21" strokeMiterlimit="10"/>
							<path d="M10.4102 494.599L304.247 450" stroke="white" strokeWidth="21" strokeMiterlimit="10"/>
							<path
								d="M272.374 770L415.685 849.732M415.685 849.732L443.151 934.97M415.685 849.732C415.685 849.732 415.765 849.815 497.044 827.262C578.323 804.708 579.444 807.196 579.444 807.196L490.718 877.343M415.685 849.732L490.718 877.343M443.151 934.97C443.151 934.97 507.694 1019.3 524.591 1022.7C541.567 1026.01 498.806 1008.52 490.718 877.343M443.151 934.97L490.718 877.343"
								stroke="white" strokeWidth="21" strokeMiterlimit="10"/>
							<path d="M115.552 592.524L553.098 722.372L624.608 657.448L324.53 583" stroke="white"
								  strokeWidth="21" strokeMiterlimit="10"/>
							<path d="M579.519 799L669.344 715.478L621.973 657L579.519 799Z" stroke="white" strokeWidth="21"
								  strokeMiterlimit="10"/>
							<path
								d="M489.888 875.569L631.851 893.476L760.741 1022.59L844.475 1086.1L950.908 1072.46L844.475 947.447V893.476L741.837 800.545L1135.11 749.114C1136.33 748.954 1136.7 750.711 1135.52 751.063L1027.18 783.442M1027.18 783.442L805.818 850.685C804.717 851.019 804.958 852.642 806.108 852.642H919.708L1027.18 783.442Z"
								stroke="white" strokeWidth="21" strokeMiterlimit="10"/>
							<path
								d="M738.609 805.557L1008.63 500.838M738.609 805.557L624.177 655.81L449.127 477.29L1008.63 500.838M738.609 805.557L632.672 890.699C632.165 891.106 631.411 890.93 631.138 890.34L552.588 720.816M1008.63 500.838L1135.27 750.39C1135.57 750.984 1136.36 751.123 1136.85 750.667L1531.54 380.526C1531.54 380.526 1494.22 320.826 1490.22 269.5L1423.6 389.895L1008.63 500.838Z"
								stroke="white" strokeWidth="21" strokeMiterlimit="10"/>
							<path d="M731.352 497.667L624.608 657.448" stroke="white" strokeWidth="21"
								  strokeMiterlimit="10"/>
							<path d="M801.02 858.687L767.867 1028.09" stroke="white" strokeWidth="21"
								  strokeMiterlimit="10"/>
							<path d="M844.649 946V1086" stroke="white" strokeWidth="21" strokeMiterlimit="10"/>
							<path d="M1260.03 435.314L1283.41 615.243" stroke="white" strokeWidth="21"
								  strokeMiterlimit="10"/>
							<path d="M1420.34 392.445L1475.68 434.899" stroke="white" strokeWidth="21"
								  strokeMiterlimit="10"/>
							<path d="M1475.68 434.899L1501.86 319.064" stroke="white" strokeWidth="21"
								  strokeMiterlimit="10"/>
							<path d="M1424.11 391.451L1487.61 382.33" stroke="white" strokeWidth="21"
								  strokeMiterlimit="10"/>
							<path d="M1528 377L1614.33 483.419" stroke="white" strokeWidth="21" strokeMiterlimit="10"/>
							<path d="M1551.99 407.371L1690.05 444.849" stroke="white" strokeWidth="21"
								  strokeMiterlimit="10"/>
							<path
								d="M254.988 439.5C268.041 393.896 326.318 207.541 490.638 98.1736C523.309 76.4494 641.424 2.90209 793.813 9.03794C1004.5 17.5784 1203.17 182.169 1301.5 415"
								stroke="white" strokeWidth="21" strokeMiterlimit="10"/>
							<path d="M1042.65 380C1042.65 380 817.596 229.928 490.638 98.1736" stroke="white"
								  strokeWidth="21" strokeMiterlimit="10"/>
							<path d="M373.79 462.5C373.79 462.5 541.567 324.371 762.903 221.803" stroke="white"
								  strokeWidth="21" strokeMiterlimit="10"/>
							<path d="M1035.17 86.8969C1035.17 86.8969 1058.15 411.848 1038.61 494.599" stroke="white"
								  strokeWidth="21" strokeMiterlimit="10"/>
							<path d="M494.722 478.928L510.097 363.922" stroke="white" strokeWidth="21"
								  strokeMiterlimit="10"/>
							<path d="M560.684 437.5L449.558 478.928" stroke="white" strokeWidth="21"
								  strokeMiterlimit="10"/>
							<path d="M586.28 485L549.094 434" stroke="white" strokeWidth="21" strokeMiterlimit="10"/>
							<path d="M1472 430L1605.5 479L1686.5 445.5L1717 411.5L1625 427" stroke="white"
								  strokeWidth="21"/>
						</g>
						<defs>
							<clipPath id="clip0">
								<rect width="1726" height="1095" fill="white"/>
							</clipPath>
						</defs>
					</svg>
				</Link>
			)
		}
	}

	const handleChange = () => {
		setIsChecked(!isChecked);
	}


	const navLinkClick = () => {
		setIsChecked(false);
	}



	return (
		<nav className="" id="mainNav">
			<div className="content grid fraction-auto">
				<aside className="logoContainer">
					{renderLogoSvg()}
				</aside>

				<aside className="navContainer">

					<input type="checkbox" className="mobileCheckbox"  checked={isChecked} onChange={handleChange}/>
					<span className="mobileToggle"> </span>
					<span className="mobileToggle"> </span>
					<span className="mobileToggle"> </span>
					<div className="navListContainer">
						<div className="content">
							<ul>
								<li><a href="#mainHeader" 	className="navLink" onClick={navLinkClick}>Hello</a></li>
								<li><a href="#projects" 	className="navLink" onClick={navLinkClick}>What I've done</a></li>
								<li><a href="#about" 		className="navLink" onClick={navLinkClick}>Who I am</a></li>
								<li><a href="#photography" 	className="navLink" onClick={navLinkClick}>Photography</a></li>
								{/*<li><a href="#blog" 		className="navLink" onClick={this._navLinkClick}>Blog</a></li>*/}
								<li><a href="#contact" 		className="navLink" onClick={navLinkClick}>Get in touch</a></li>
							</ul>
						</div>
					</div>

				</aside>
			</div>
		</nav>
	);

}

export default Navigation